<template>
    <div>
      <v-container class="mb-5">
        <v-tabs ref="category"
          v-model="active"
          color="#5a65db"
          dark
          slider-color="#5a65db"
          class="analytics-tab-menu-cat"
          centered
        >
          <div class="categories">
                    <v-tab key="productCat" :ripple="false" class="cat mr-3">
                     <span class="mt-3">{{$t('settings.product_cat')}}</span>
                    </v-tab>
                    <v-tab key="needCat" class="cat" :ripple="false">
                      <span class="mt-3"> {{$t('settings.need_cat')}}</span>
                    </v-tab>
          </div>
          <v-tab-item>
            <ProductCategory></ProductCategory>
          </v-tab-item>
          <v-tab-item>
            <NeedCategory></NeedCategory>
          </v-tab-item>
        </v-tabs>
      </v-container>
    </div>
</template>

<script>
import ProductCategory from './ProductCategory'
import NeedCategory from './NeedCategory'

export default {
  name: 'Categories',
  components: {
    ProductCategory,
    NeedCategory
  },
  data: () => ({
    active: null,
    count: '',
    show: false
  }),
  mounted () {
    this.$refs.category.$el.querySelector('.v-tabs__bar').addEventListener('touchstart', function (ev) {
      ev.stopPropagation()
    })
    this.$refs.category.$el.querySelector('.v-tabs__bar').addEventListener('touchend', function (ev) {
      ev.stopPropagation()
    })
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/desktop/analyticsPage.scss";
</style>



// WEBPACK FOOTER //
// src/components/profilePage/components/Categories.vue